import type { TFunction } from 'i18next'

interface AxiosLike {
  response?: { status?: number; data?: { error?: string; message?: string } }
}

export function getAuthError(err: unknown, t: TFunction, context: 'login' | 'signup' | 'reset' = 'login'): string {
  const e = err as AxiosLike
  const status = e?.response?.status
  const serverMsg = e?.response?.data?.error ?? e?.response?.data?.message ?? ''

  if (!status) return t('auth.error_network')

  if (status === 401) return t('auth.error_credentials')
  if (status === 403) return t('auth.error_suspended')
  if (status === 429) return t('auth.error_rate_limit')

  if (status === 409 && context === 'signup') {
    if (/username/i.test(serverMsg)) return t('auth.error_username_taken')
    if (/email/i.test(serverMsg)) return t('auth.error_email_taken')
  }

  // passwordReset()'s only failure mode besides rate-limiting is an
  // invalid/already-used/expired token (auth.service.ts, 400) — that's the
  // one case this context should still label as "get a new link" rather
  // than the generic catch-all.
  if (status === 400 && context === 'reset') return t('auth.reset_error_expired')

  return t('auth.error_generic')
}
